// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conf-btn[data-v-536b0fe2] {
  position: relative;
  color: var(--color);
  min-width: var(--min-width);
}
.conf-btn .btn-wrapper[data-v-536b0fe2] {
  display: flex;
  flex-direction: var(--wrapper-flex-direction);
  -webkit-app-region: no-drag;
}
.conf-btn[data-v-536b0fe2]:not(.disabled),
.conf-btn.clickable[data-v-536b0fe2] {
  cursor: pointer;
}
.conf-btn:not(.disabled) i[data-v-536b0fe2],
.conf-btn.clickable i[data-v-536b0fe2],
.conf-btn:not(.disabled) .sub-title[data-v-536b0fe2],
.conf-btn.clickable .sub-title[data-v-536b0fe2],
.conf-btn:not(.disabled) .after[data-v-536b0fe2],
.conf-btn.clickable .after[data-v-536b0fe2] {
  opacity: 0.7;
}
.conf-btn:not(.disabled) .chevron[data-v-536b0fe2],
.conf-btn.clickable .chevron[data-v-536b0fe2] {
  display: flex;
}
.conf-btn .chevron[data-v-536b0fe2] {
  position: absolute;
  right: 0;
  height: 20px;
  width: 20px;
  font-size: 10px;
  border-radius: 3px;
}
.conf-btn .chevron[data-v-536b0fe2]:hover {
  background-color: var(--vm-bg-color-hover);
}
.conf-btn .chevron i[data-v-536b0fe2] {
  margin: auto;
}
.conf-btn.disabled[data-v-536b0fe2] {
  opacity: 0.5;
}
.conf-btn .image-wrapper[data-v-536b0fe2] {
  height: var(--size);
  width: var(--size);
  display: flex;
  margin: auto;
}
.conf-btn .image-wrapper > *[data-v-536b0fe2] {
  margin: auto;
}
.conf-btn .image-wrapper i[data-v-536b0fe2] {
  font-size: var(--icon-size);
}
.conf-btn .image-wrapper i.fa-rotate-180[data-v-536b0fe2] {
  transform: translate(0px, -1px) rotate(180deg);
}
.conf-btn .sub-title[data-v-536b0fe2] {
  font-size: var(--font-size);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: auto;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/confBtn.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,2BAA2B;AAC7B;AACA;;EAEE,eAAe;AACjB;AACA;;;;;;EAME,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".conf-btn[data-v-536b0fe2] {\n  position: relative;\n  color: var(--color);\n  min-width: var(--min-width);\n}\n.conf-btn .btn-wrapper[data-v-536b0fe2] {\n  display: flex;\n  flex-direction: var(--wrapper-flex-direction);\n  -webkit-app-region: no-drag;\n}\n.conf-btn[data-v-536b0fe2]:not(.disabled),\n.conf-btn.clickable[data-v-536b0fe2] {\n  cursor: pointer;\n}\n.conf-btn:not(.disabled) i[data-v-536b0fe2],\n.conf-btn.clickable i[data-v-536b0fe2],\n.conf-btn:not(.disabled) .sub-title[data-v-536b0fe2],\n.conf-btn.clickable .sub-title[data-v-536b0fe2],\n.conf-btn:not(.disabled) .after[data-v-536b0fe2],\n.conf-btn.clickable .after[data-v-536b0fe2] {\n  opacity: 0.7;\n}\n.conf-btn:not(.disabled) .chevron[data-v-536b0fe2],\n.conf-btn.clickable .chevron[data-v-536b0fe2] {\n  display: flex;\n}\n.conf-btn .chevron[data-v-536b0fe2] {\n  position: absolute;\n  right: 0;\n  height: 20px;\n  width: 20px;\n  font-size: 10px;\n  border-radius: 3px;\n}\n.conf-btn .chevron[data-v-536b0fe2]:hover {\n  background-color: var(--vm-bg-color-hover);\n}\n.conf-btn .chevron i[data-v-536b0fe2] {\n  margin: auto;\n}\n.conf-btn.disabled[data-v-536b0fe2] {\n  opacity: 0.5;\n}\n.conf-btn .image-wrapper[data-v-536b0fe2] {\n  height: var(--size);\n  width: var(--size);\n  display: flex;\n  margin: auto;\n}\n.conf-btn .image-wrapper > *[data-v-536b0fe2] {\n  margin: auto;\n}\n.conf-btn .image-wrapper i[data-v-536b0fe2] {\n  font-size: var(--icon-size);\n}\n.conf-btn .image-wrapper i.fa-rotate-180[data-v-536b0fe2] {\n  transform: translate(0px, -1px) rotate(180deg);\n}\n.conf-btn .sub-title[data-v-536b0fe2] {\n  font-size: var(--font-size);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin: auto;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
